import { ListLink, ListProps } from "@/components";

export type Props = ListProps;

export const ListNotification: React.FC<Props> = (props) => {
  return <ListLink {...props} />;
};
